import MyAssetsPage from "./MyAssetsPage";

export default {
    list: MyAssetsPage,
    //create: MyPunchesPage,
};